import { AutoCompleteOption } from '../../ApiClientTypes';

export const mapAutocompleteData = (autocompleteResponse: any): Array<AutoCompleteOption> => {
  return autocompleteResponse;
};
